import { Component } from "@angular/core";
import {
  NavController,
  ToastController,
  LoadingController,
  ViewController,
  NavParams,
  ModalController,
  Modal,
} from "ionic-angular";

import { Master, Tracking, Item } from "@providers/asset/index";
import { FormItemPage } from "../form_item/page";
import { FormLocationPage } from "../form_location/page";
import { ItemPage, DetailImagePage } from "../";

@Component({
  selector: "page-location",
  templateUrl: "page.html",
})
export class LocationPage {
  List: any = [];
  tracking = 0;
  review = 0;
  pilihModal = 0;
  selectedLocation: any = {};
  list_path: any = [];
  url_image = "";
  location_selected: any = {};
  location_image = null;

  constructor(
    public navCtrl: NavController,
    public masterApi: Master,
    public itemApi: Item,
    public trackingApi: Tracking,
    public toastCtrl: ToastController,
    public loadingCtrl: LoadingController,
    public viewCtrl: ViewController,
    public modalCtrl: ModalController,
    public navParams: NavParams
  ) {
    this.pilihModal = navParams.get("pilih");
    if (navParams.get("tracking") != undefined) {
      this.tracking = navParams.get("tracking");
      this.trackingApi.active = 1;
      this.trackingApi.review = 0;
    }
    if (navParams.get("review") != undefined) {
      this.review = navParams.get("review");
      this.trackingApi.active = 0;
      this.trackingApi.review = 1;
    }
    this.url_image = itemApi.base_url + "/client/uploads/";
  }

  ionViewDidEnter() {
    this.getList();
  }

  doRefresh(refresher) {
    refresher.complete();
    this.getList();
  }

  getPath(location_path) {
    let loading = this.loadingCtrl.create({
      content: "Please wait...",
    });
    loading.present();

    let params = { location_path: location_path };

    this.masterApi.getLocation(params).subscribe(
      (resp: any) => {
        if (resp.data.length > 0) {
          this.list_path = resp.data;
        } else {
        }
        loading.dismiss();
      },
      (err) => {
        loading.dismiss();
      }
    );
  }

  getList() {
    let loading = this.loadingCtrl.create({
      content: "Please wait...",
    });
    loading.present();

    let params = { parent_id: this.selectedLocation.id };
    let get: any;

    if (this.tracking != 1) {
      get = this.masterApi.getLocation(params);
    } else {
      get = this.trackingApi.get_location(params);
    }

    get.subscribe(
      (resp: any) => {
        if (resp.data.length > 0) {
          this.List = resp.data;
        } else {
          this.toastCtrl
            .create({
              message: "Data sub location not found",
              duration: 3000,
              position: "top",
            })
            .present();
        }
        loading.dismiss();
      },
      (err) => {
        loading.dismiss();
      }
    );
  }

  getSub(item, e) {
    // if(e.toElement.className=='button-inner' || item.subs==0){
    //   return;
    // }
    if (item.generated_name == null) {
      this.location_image = null;
    } else {
      this.location_image = this.url_image + "/" + item.generated_name;
      this.location_selected = item;
    }
    console.log(item);

    this.getPath(item.location_path_id);
    this.selectedLocation = item;
    this.getList();
  }

  selectPath(item) {
    if (item.generated_name == null) {
      this.location_image = null;
    } else {
      this.location_image = this.url_image + "/" + item.generated_name;
      this.location_selected = item;
    }
    console.log(item);

    this.getPath(item.location_path_id);
    this.selectedLocation = item;
    this.getList();
  }

  getItems(item) {
    let params = { location: item, tracking: this.tracking };
    this.navCtrl.push(ItemPage, params);
  }

  pilih(item) {
    let data = { item: item };
    this.viewCtrl.dismiss(data);
  }

  addSub(item) {
    let params = { parent: item };
    this.navCtrl.push(FormLocationPage, params);
  }

  edit(item) {
    let params = { item: item };
    this.navCtrl.push(FormLocationPage, params);
  }

  addItem(item) {
    let params = { location: item };
    this.navCtrl.push(FormItemPage, params);
  }

  viewImage() {
    let profileModal = this.modalCtrl.create(DetailImagePage, {
      url_image: this.url_image + this.location_selected.generated_name,
      detail: this.location_selected,
    });
    profileModal.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/asset/location/page.ts